export const GETALL_REFERENCES = "GETALL_REFERENCES"
export const GETALL_REFERENCES_SUCCESS = "GETALL_REFERENCES_SUCCESS"
export const GETALL_REFERENCES_FAILED = "GETALL_REFERENCES_FAILED"


export const CREATE_REFERENCE = "CREATE_REFERENCE"
export const CREATE_REFERENCE_SUCCESS = "CREATE_REFERENCE_SUCCESS"
export const CREATE_REFERENCE_FAILED = "CREATE_REFERENCE_FAILED"


export const UPDATE_REFERENCE = "UPDATE_REFERENCE"
export const UPDATE_REFERENCE_SUCCESS = "UPDATE_REFERENCE_SUCCESS"
export const UPDATE_REFERENCE_FAILED = "UPDATE_REFERENCE_FAILED"


export const VIEW_REF_FILES = "VIEW_REF_FILES"
export const VIEW_REF_FILES_SUCCESS = "VIEW_REF_FILES_SUCCESS"
export const VIEW_REF_FILES_FAILED = "VIEW_REF_FILES_FAILED"

export const UPLOAD_REF_FILES = "UPLOAD_REF_FILES"
export const UPLOAD_REF_FILES_SUCCESS = "UPLOAD_REF_FILES_SUCCESS"
export const UPLOAD_REF_FILES_FAILED = "UPLOAD_REF_FILES_FAILED"

export const DOWNLOAD_REFERENCE = "DOWNLOAD_REFERENCE"
export const DOWNLOAD_REFERENCE_SUCCESS = "DOWNLOAD_REFERENCE_SUCCESS"
export const DOWNLOAD_REFERENCE_FAILED = "DOWNLOAD_REFERENCE_FAILED"